import global from "../global.js";
import Error from "../utils/Error.js";

import StateMachine from "statemachine";

import PQueue from "p-queue/dist/index.js";

const log = global.log.getLogger("f_mtac.subscribe");
log.setLevel(log.levels.WARN);

let Subscribe = function(server) {
    var room = null;
    var socket = null;

    var socket_object_handler = null;
    var socket_configuration_handler = null;
    var socket_message_handler = null;
    var socket_room_handler = null;
    var socket_user_handler = null;

    var subcribe_address = (space) => {
        let server_url = new URL(server.configuration.address), server_protocol, server_host;
        if (server_url.protocol == "https:") {
            server_protocol = "wss:";
            if (!server_url.port) {
                server_host = `${server_url.hostname}:443`;
            } else {
                server_host = `${server_url.hostname}:${server_url.port}`;
            }
        } else if (server_url.protocol == "http:") {
            server_protocol = "ws:";
            server_host = `${server_url.host}`;
        } else {
            throw new Error.build.invalid({
                message: "unsupported protocol"
            });
        }
        return `${server_protocol}//${server_host}${server_url.pathname}/subscribe?space=${space}`;
    };

    this.init = (new_room) => {
        room = new_room;
    };

    this.deinit = () => {
        return this.disconnect().then(() => {
            room = null;
        });
    };

    var socket_rx_handler_object = async ({desktop_id, global_hash, remote_id, old_hash, new_hash, data}) => {
        if (socket_object_handler === null) {
            return;
        }
        var object = {
            global_hash: null,
            old_hash: null,
            new_hash: null,
            data: null
        };
        object.global_hash = global_hash;
        object.remote_id = remote_id;
        if (old_hash !== undefined) {
            object.old_hash = old_hash;
        }
        if (new_hash !== undefined) {
            object.new_hash = new_hash;
        }
        if (data !== undefined) {
            object.data = data;
        }
        return socket_object_handler(desktop_id, object);
    };

    var socket_rx_handler_configuration = async ({desktop_id, name, old_hash, new_hash, data}) => {
        if (socket_configuration_handler === null) {
            return;
        }
        var configuration = {
            old_hash: null,
            new_hash: null,
            data: null
        };
        configuration.name = name;
        if (old_hash !== undefined) {
            configuration.old_hash = old_hash;
        }
        if (new_hash !== undefined) {
            configuration.new_hash = new_hash;
        }
        if (data !== undefined) {
            configuration.data = JSON.parse(data);
        }
        return socket_configuration_handler(desktop_id, configuration);
    };

    var socket_rx_handler_message = ({channel_id, data}) => {
        if (socket_message_handler === null) {
            return;
        }
        return socket_message_handler(channel_id, data);
    };

    var socket_rx_handler_room_data = async ({desktop_id, name, status}) => {
        if (socket_room_handler === null) {
            return;
        }
        var room_data = {
            name: null,
            status: null
        };
        if (name !== undefined) {
            room_data.name = name;
        }
        if (status !== undefined) {
            room_data.status = status;
        }
        return socket_room_handler(desktop_id, room_data);
    };

    var socket_rx_handler_user_data = async ({status, login, name, capabilities}) => {
        if (socket_user_handler === null) {
            return;
        }
        var user_data = {
            login: null,
            name: null,
            capabilities: null
        };
        user_data.login = login;
        user_data.name = name;
        user_data.capabilities = capabilities;
        user_data.status = status;
        return socket_user_handler(user_data);
    };

    const rx_queue = new PQueue({concurrency: 1});

    var socket_rx_handler = (socket_event) => {
        var data;
        try {
            data = JSON.parse(socket_event.data);
        } catch(error) {
            log.error("failed to parse message data", error);
            return;
        }
        switch(data.type) {
        case "object":
            return rx_queue.add(() => socket_rx_handler_object(data));
        case "configuration":
            return rx_queue.add(() => socket_rx_handler_configuration(data));
        case "message":
            return rx_queue.add(() => socket_rx_handler_message(data));
        case "room":
            return rx_queue.add(() => socket_rx_handler_room_data(data));
        case "user":
            return rx_queue.add(() => socket_rx_handler_user_data(data));
        }
    };

    var socket_error_handler = function(error) {
        log.error("websocket error:", error);
        if (sm.state.name === "disconnected") {
            return;
        }
        socket.removeEventListener("error", socket_error_handler);
        socket.removeEventListener("close", socket_close_handler);
        socket = null;
        sm.transition.lost_connection({});
        server.network.cut();
        server.network.ping().catch(() => log.info("connection effectively lost"));
    };

    var socket_close_handler = (event) => {
        log.error("websocket was closed by remote party or connection state", event);
        if (sm.state.name === "disconnected") {
            return;
        }
        socket.removeEventListener("error", socket_error_handler);
        socket.removeEventListener("close", socket_close_handler);
        socket = null;
        sm.transition.lost_connection({});
        server.network.cut();
        server.network.ping().catch(() => log.info("connection effectively lost"));
    };

    var handle_offline = () => {};

    var handle_online = () => {
        if (sm.state.name === "lost_connection") {
            sm.transition.connected({});
        }
    };

    var socket_connect = async () => {
        if (room === null) {
            return null;
        }
        if (socket !== null) {
            return socket;
        }
        try {
            var new_socket = new WebSocket(subcribe_address(room.space));
        } catch(error) {
            log.error("failed to create a new websocket");
            sm.transition.lost_connection({});
            return null;
        }
        socket = new_socket;
        return await new Promise(resolve => {
            
            var socket_error = () => {
                new_socket.removeEventListener("open", socket_open);
                new_socket.removeEventListener("error", socket_error);
                if (socket === new_socket) {
                    socket = null;
                }
                resolve(new_socket);
                sm.transition.lost_connection({});
            };
            var socket_open = () => {
                new_socket.removeEventListener("open", socket_open);
                new_socket.removeEventListener("error", socket_error);
                new_socket.addEventListener("close", socket_close_handler);
                new_socket.addEventListener("error", socket_error_handler);
                new_socket.addEventListener("message", socket_rx_handler);
                resolve(new_socket);
            };
            new_socket.addEventListener("open", socket_open);
            new_socket.addEventListener("error", socket_error);
        });
    };

    var socket_disconnect = async () => {
        if (socket === null) {
            return null;
        }
        var old_socket = socket;
        socket = null;
        return await new Promise((resolve) => {
            let socket_error = () => {
                log.error("error while closing socket");
            };
            old_socket.removeEventListener("message", socket_message_handler);
            old_socket.removeEventListener("error", socket_error_handler);
            old_socket.removeEventListener("close", socket_close_handler);
            old_socket.addEventListener("error", socket_error);
            try {
                old_socket.close();
            } catch (error) {
                log.warn("failed to close socket in an invalid state");
            }
            resolve(null);
        });
    };

    var sm = new StateMachine({
        name: "subscribe",
        shared_data: {},
        default_state: "disconnected",
        states: {
            disconnected: {
                in: () => {
                    log.debug("Subscribe.sm publish 'subscribe.disconnected'");
                    global.event_bus.publish("subscribe.disconnected");
                    window.removeEventListener("f_mtac.network.offline", handle_offline);
                    window.removeEventListener("f_mtac.network.online", handle_online);
                },
                out: () => {
                    window.addEventListener("f_mtac.network.offline", handle_offline);
                    window.addEventListener("f_mtac.network.online", handle_online);
                },
                transit: {
                    connect: {
                        state: "connected",
                        handler: () => true
                    }
                },
                schedule: {}
            },
            lost_connection: {
                in: () => {
                    log.debug("Subscribe.sm publish 'subscribe.lost_connection'");
                    global.event_bus.publish("subscribe.lost_connection");
                },
                out: () => {},
                transit: {
                    reconnect: {
                        state: "connected",
                        handler: async () => {
                            if (socket !== null) {
                                return true;
                            }
                            log.info("trying to reconnect socket");
                            await socket_connect();
                            if (socket === null) {
                                return false;
                            }
                            return true;
                        }
                    },
                    disconnect: {
                        state: "disconnected",
                        handler: () => true
                    }
                },
                schedule: {
                    reconnect: {
                        handler: async () => {
                            sm.transition.connected({});
                        },
                        interval: 10e3, // 10 * 1s = 10 seconds
                        repeat: Infinity
                    }
                }
            },
            connected: {
                in: () => {
                    log.debug("Subscribe.sm publish subscribe.connected");
                    global.event_bus.publish("subscribe.connected");
                    socket_connect();
                },
                out: () => {
                    socket_disconnect();
                },
                transit: {
                    lose_connection: {
                        state: "lost_connection",
                        handler: async () => {
                            if (socket !== null) {
                                return false;
                            }
                            return true;
                        }
                    },
                    disconnect: {
                        state: "disconnected",
                        handler: () => true
                    }
                },
                schedule: {
                    ping: {
                        handler: async () => {
                            if (socket === null) {
                                return;
                            }
                            try {
                                socket.send("{}");
                            } catch(error) {
                                log.warn("failed to send on socket: temporary failure");
                            }
                        },
                        interval: 5e3, // 5 * 1s = 5 seconds
                        repeat: Infinity
                    }
                }
            }
        }
    });

    this.on = (message_type, handler) => {
        switch(message_type) {
        case "object":
            socket_object_handler = handler;
            break;
        case "configuration":
            socket_configuration_handler = handler;
            break;
        case "message":
            socket_message_handler = handler;
            break;
        case "room":
            socket_room_handler = handler;
            break;
        case "user":
            socket_user_handler = handler;
            break;
        }
    };

    this.connect = async () => {
        await sm.transition.connected({});
    };

    this.disconnect = async () => {
        await sm.transition.disconnected({});
    };
    let debug_offline = () => {
        this.disconnect();
    };
    let debug_online = () => {
        this.connect();
    };
    this.debug = function() {
        window.addEventListener("f_mtac.network.offline", debug_offline);
        window.addEventListener("f_mtac.network.online", debug_online);
    };
};

export default Subscribe;
